import { render, staticRenderFns } from "./chipTextDataField.vue?vue&type=template&id=6e6407c9&scoped=true"
import script from "./chipTextDataField.vue?vue&type=script&lang=js"
export * from "./chipTextDataField.vue?vue&type=script&lang=js"
import style0 from "./chipTextDataField.vue?vue&type=style&index=0&id=6e6407c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6407c9",
  null
  
)

export default component.exports